import { GameData, SceneId } from "./gameData";

export interface GameContext {
    gameData: GameData;
    gameState: GameState;
}

export interface GameState {
    state: "video" | "input";
    currentSceneId: SceneId;
    visitedScenes: Set<SceneId>;
    isPlaying: boolean;
    sceneHistory: SceneId[];
}

export function createGameContext(gameData: GameData): GameContext {
    const gameContext: GameContext = {
        gameData,
        gameState: {
            currentSceneId: gameData.initialSceneId,
            state: "video",
            visitedScenes: new Set(),
            isPlaying: false,
            sceneHistory: [],
        },
    };
    window.gameContext = gameContext;
    return gameContext;
}
